import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StreamTexture from '../../../public/js/chyronhego/plugin/StreamTexture';
import Settings from '../../settings';
import { actions as clipperMovieActions } from '../../actions/clipperMovie';
import LoadingIndicator from '../LoadingIndicator';

const Player = styled.embed`
  padding: 0;
  margin: 0;
  height: 360px;
  width: 640px;
  z-index: 1;
`;

class MovieStream extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      isSupported: true,
    };

    this.streamTextures = [];

    this.audio = '';
    this.volume = 1;
    this.interlace = false;
    this.flip = false;
    this.ssl = false;
    this.loaded = false;
    this.connected = false;
    this.muted = false;

    this.streamWidth = 1920 * 2;
    this.streamHeight = 1080;

    this.onWindowResize = this.onWindowResize.bind(this);
    this.onMessage = this.onMessage.bind(this);
    this.updateStreams = this.updateStreams.bind(this);
  }
  UNSAFE_componentWillMount() {
    if (navigator.mimeTypes['application/x-pnacl'] === undefined) {
      console.log('Stream Plugin is not supported in this browser');
      this.setState({ isSupported: false });
    } else {
      window.addEventListener('resize', this.onWindowResize);
      window.addEventListener('message', this.onMessage, true);
    }
  }
  componentDidMount() {
    if (!this.state.isSupported) {
      return;
    }

    console.log('Stream Plugin loaded');
    this.loaded = true;

    this.address = Settings.streamServer.replace(/.*:\/\//, '');  // streaming server location without protocol
    this.port = 9000;

    this.connect();

    const texture = new StreamTexture('ClipperTexture');
    this.addStreamTexture(texture);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('message', this.onMessage);
  }
  onWindowResize() {
    this.streamTextures.forEach(texture => {
      texture.setPosition(0, 0, window.innerWidth, window.innerHeight);
    });
  }
  onMessage(event) {
    const parts = event.data.split(':');
    if (parts.length > 1) {
      if (parts[1] === 'P') {
        this.handlePositionUpdate(parts);
      } else if (parts.length === 3 && parts[1] === 'D') {
        this.handleDimensionUpdate(parts[2]);
      } else if (parts.length === 3 && parts[1] === 'H') {
        this.handleConnectionUpdate(parts[2]);
      } else if (parts[1] === 'A') {
        this.handleAudioUpdate(parts);
      } else if (parts[1] === 'V') {
        // TODO: implement vu meters
      }
    }
  }
  setStreamSize(w, h) {
    this.streamWidth = w;
    this.streamHeight = h;

    this.streamTextures.forEach(texture => {
      texture.setStreamSize(this.streamWidth, this.streamHeight);
    });
  }
  setPids(pids) {
    this.pids = pids;
    this.updateAudio();
  }
  connect() {
    console.log(`Stream Plugin: connecting to ${this.address}:${this.port}`);

    this.player.postMessage(`i:${this.interlace ? 1 : 0}`);
    this.player.postMessage(`s:${this.ssl ? 1 : 0}`);
    this.player.postMessage(`f:${this.flip ? 1 : 0}`);
    this.player.postMessage(`c:${this.address}:${this.port}`);

    this.connected = true;

    this.updateStreams();
  }
  addStreamTexture(texture) {
    texture.setStreamSize(this.streamWidth, this.streamHeight);
    texture.setTexturePosition(0, 0, this.streamWidth / 2, this.streamHeight);
    texture.setPosition(0, 0, window.innerWidth, window.innerHeight);
    texture.on('change', this.updateStreams);
    this.streamTextures.push(texture);
    this.updateStreams();
  }
  updateStreams() {
    const message = this.streamTextures.length > 0 ?
      `l:${this.streamTextures.join(',')}` :
      'l: ';

    this.player.postMessage(message);
  }
  updateAudio() {
    const numPids = this.pids.length;
    const pids = this.pids.slice();
    for (let i = 0; i < numPids; i++) {
      pids.slice(1 + (i * 2), 0, this.muted ? 0 : this.volume);
    }

    const audio = pids.join(':');
    this.player.postMessage(`v:${audio}`);
  }
  handlePositionUpdate(parts) {
    const str = parts.slice(2).join(':');
    try {
      const json = JSON.parse(str);
      if (json && json.top_left && json.top_left.playhead && json.top_left.playhead.position) {
        if (this.props.isPlaying || !this.state.initialized) {
          this.props.onUpdate(json.top_left.playhead.position[0]);
          if (!this.state.initialized) {
            this.setState({ initialized: true });
          }
        }
      }
    } catch (error) {
      console.log(str, error);
    }
  }
  handleDimensionUpdate(dimensions) {
    const obj = dimensions.split('x');
    this.setStreamSize(obj[0], obj[1]);
  }
  handleAudioUpdate(parts) {
    const pids = parts.slice(2).map((pid) => parseInt(pid, 10));
    this.setPids(pids);
  }
  handleConnectionUpdate(connection) {
    if (connection === 'disconnected') {
      this.connected = false;
      console.log(`disconnected from ${this.address}:${this.port}`);
    } else if (connection === 'connected') {
      this.connected = true;
      console.log(`connected to ${this.address}:${this.port}`);
    }
  }
  render() {
    if (this.state.isSupported) {
      return (
        <div>
          <LoadingIndicator visible={!this.connected} />
          <Player
            ref={embed => { this.player = embed; }}
            src="plugin/stream.nmf"
            type="application/x-pnacl"
          />
        </div>
      );
    }

    return (
      <div>Stream Plugin is not supported in this browser</div>
    );
  }
}

MovieStream.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isPlaying: state.clipperMovie.isPlaying
});

const mapDispatchToProps = {
  onUpdate: clipperMovieActions.updateVideoFrame
};

export default connect(mapStateToProps, mapDispatchToProps)(MovieStream);



// WEBPACK FOOTER //
// ./app/components/Clipper/MovieStream.js